import { ButtonProps } from 'react-bootstrap';

import CommunityTab from 'components/StyledTemplates/CommunityTab';
import PopUpWrapper from 'components/StyledTemplates/PopUpWrapper';
import { Button, TExtra } from 'components/StyledTemplates/StyledTemplates';

import useModal from 'hooks/useModal';
import useResources from 'hooks/useResources';

export type ModalityState = {
    title: string | JSX.Element;
    body: string | JSX.Element;
    options?: {
        confirmButton?: string;
        closeButton?: string;
        onConfirm?: () => void | Promise<unknown>;
        onCancel?: () => void | Promise<unknown>;
        closeOnConfirm?: boolean;
        displayConfirmButton?: boolean;
        displayCloseButton?: boolean;
        displayCloseCross?: boolean;
        closeButtonVariant?: ButtonProps['variant'];
        confirmButtonVariant?: ButtonProps['variant'];
        size?: 'sm' | 'md' | 'lg' | 'xl';
        className?: string;
        footerClassName?: string;
        extra?: TExtra;
    };
};

const Modality = () => {
    const { t } = useResources();

    const { state, close } = useModal('MODALITY') as { state: ModalityState; [key: string]: any };
    const { title, body, options = {} } = state ?? {};
    const {
        className = '',
        extra = '',
        footerClassName = '',
        closeButtonVariant = 'light',
        confirmButtonVariant = 'primary',
    } = options;

    const handlers = {
        onCancelButton: async () => {
            if (options.onCancel) {
                options.onCancel();
            }
            close();
        },
        onConfirmButton: async () => {
            if (options?.onConfirm) {
                await options.onConfirm();
            }
            if (options?.closeOnConfirm !== false) {
                close();
            }
        },
    };
    return (
        <PopUpWrapper
            name="MODALITY"
            whiteCross={true}
            withCross={options?.displayCloseCross !== false}
            size={options?.size ?? 'lg'}
            onClickOutside={() => {
                if (options?.onCancel) {
                    options.onCancel();
                }
            }}
        >
            <CommunityTab title={title} className={className} extraBody={`align-items: flex-start; ${extra}`}>
                {body}
                <div className={`${footerClassName} w-100 d-flex flex-row justify-content-end gap-1 mt-2`}>
                    {options?.displayCloseButton !== false && (
                        <Button data-qaid="close_button" variant={closeButtonVariant} onClick={handlers.onCancelButton}>
                            {options?.closeButton ?? t('modals.MODALITY.closeButton')}
                        </Button>
                    )}
                    {options?.displayConfirmButton !== false && (
                        <Button
                            data-qaid="confirm_button"
                            variant={confirmButtonVariant}
                            onClick={handlers.onConfirmButton}
                        >
                            {options?.confirmButton ?? t('modals.MODALITY.confirmButton')}
                        </Button>
                    )}
                </div>
            </CommunityTab>
        </PopUpWrapper>
    );
};

export default Modality;
